/**
 * Created by nmayer on 09.06.16.
 */
define('modules/settings/tax/TaxController',['modules/module', 'settings', 'modules/basemodule/controllers/EntityListController'], function (module) {
	'use strict';
	module.controller('TaxController', [
		'$scope',
		'$controller',
		'BASE_TEMPLATES_PATH',
		function ($scope, $controller, BASE_TEMPLATES_PATH) {
			angular.extend(
				this,
				$controller('EntityListController', {
					$scope: $scope,
				})
			);

			$scope.state.requireSuperuserForDelete = true;

			$scope.tableOptions.fields = [
				{
					id: 'NAME',
					heading: 'FIELDS.NAME',
					attribute: 'name',
				},
				{
					id: 'TAX',
					heading: 'FIELDS.TAX_RATE',
					template: BASE_TEMPLATES_PATH + '/settings/tax/tax-value-col.html',
					attribute: 'value',
				},
			];
			$scope.formState = 'root.tax';

			$scope.init('Tax');
		},
	]);
});

